<div class="heading">
    <p *ngIf="dialogData?.is_active">Inactivate Model</p>
    <p *ngIf="!dialogData?.is_active">Activate Model</p>
</div>
<div class="model-instruction">
    <p class="mb-32" *ngIf="dialogData?.is_active">Are you sure you want to inactivate “{{dialogData?.name}}” model? Once inactivated, it will no longer be available to end users.</p>
    <p class="mb-32" *ngIf="!dialogData?.is_active">Are you sure you want to activate “{{dialogData?.name}}” model?</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12" (click)="cancelActiveInactivateModel()"></app-button>
    <app-button [type]="'primary'" *ngIf="dialogData?.is_active" [buttonType]="'button'" [buttonText]="'Inactivate'" class="w-50" (click)="activeInactivateModel()"></app-button>
    <app-button [type]="'primary'" *ngIf="!dialogData?.is_active" [buttonType]="'button'" [buttonText]="'Activate'" class="w-50" (click)="activeInactivateModel()"></app-button>
</div>